//declare global {
interface String {
    format(): string;
}

interface Number {
    formatMoney(c: number, d?: string, t?: string): string;
}
//}





String.prototype.format = function () {
    return "AAA";
}



Number.prototype.formatMoney = function (c: number, d?: string, t?: string) {
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? " " : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        ii = parseInt(n = Math.abs(Number(n) || 0).toFixed(c)),
        j: number = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - ii).toFixed(c).slice(2) : "");
};

/*
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}

*/
